import React from "react";
import { OrgChartsList } from "../../../quality/org-charts/list";

/**
 * HSE/KS Org Charts List - Organisasjonskart (ISO 9001:2015 kap. 5.3)
 * Uses existing OrgChartsList component directly
 */
export const HseKsOrgChartsList = () => {
  return <OrgChartsList />;
};

